"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderFromJSON = exports.Sleep = exports.checkResultFast = exports.checkResult = exports.getTokenList = exports.orderSigEncode = exports.orderParamsEncode = exports.hashOrder = exports.getSchemaList = exports.getAccountBalance = exports.web3Sign = exports.makeBigNumber = exports.assetToMetadata = exports.getAPENFTAssetURI = exports.toBaseUnitAmount = void 0;
var index_1 = require("../schemas/index");
var tokens_1 = require("../tokens");
var constants_1 = require("./constants");
function toBaseUnitAmount(amount, decimals) {
    var unit = new constants_1.BigNumber(10).pow(decimals);
    return amount.times(unit).integerValue();
}
exports.toBaseUnitAmount = toBaseUnitAmount;
var getAPENFTAssetURI = function (contract, tokenId) { return __awaiter(void 0, void 0, void 0, function () {
    var overURI, URI;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, contract.APENFTSharedAsset.methods._getOverrideURI(tokenId).call()];
            case 1:
                overURI = _a.sent();
                return [4 /*yield*/, contract.APENFTSharedAsset.methods.uri(tokenId).call()];
            case 2:
                URI = _a.sent();
                return [2 /*return*/, { overURI: overURI, URI: URI }];
        }
    });
}); };
exports.getAPENFTAssetURI = getAPENFTAssetURI;
function assetToMetadata(asset, quantity) {
    var orderMetadata = {
        asset: {
            id: asset.tokenId,
            address: asset.tokenAddress,
            quantity: quantity
        },
        schema: asset.schemaName
    };
    return orderMetadata;
}
exports.assetToMetadata = assetToMetadata;
function makeBigNumber(arg) {
    // Zero sometimes returned as 0x from contracts
    if (arg === '0x') {
        arg = 0;
    }
    // fix "new BigNumber() number type has more than 15 significant digits"
    arg = arg.toString();
    return new constants_1.BigNumber(arg);
}
exports.makeBigNumber = makeBigNumber;
function web3Sign(web3, msg, account) {
    return __awaiter(this, void 0, void 0, function () {
        var hash, hexStrWithout0x, byteArray, signatureRes, tail, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    hash = msg;
                    if (web3.utils.isString(msg) && !web3.utils.isHex(msg)) {
                        hexStrWithout0x = web3.toHex(msg).replace(/^0x/, '');
                        byteArray = web3.utils.code.hexStr2byteArray(hexStrWithout0x);
                        hash = web3.utils.ethersUtils.keccak256(byteArray).replace(/^0x/, '');
                    }
                    // type===2 ledger wallet address
                    // type===0 general wallet address
                    if (web3.defaultAddress && web3.defaultAddress.type !== 2) {
                        hash += '1';
                    }
                    return [4 /*yield*/, web3.trx.sign(hash.replace(/^0x/, ''))];
                case 1:
                    signatureRes = _a.sent();
                    tail = signatureRes.substring(128, 130);
                    if (tail == '01') {
                        signatureRes = signatureRes.substring(0, 128) + '1c';
                    }
                    else if (tail == '00') {
                        signatureRes = signatureRes.substring(0, 128) + '1b';
                    }
                    console.log('msg to sign', msg);
                    console.log('hash to sign', hash);
                    console.log('signatureRes', signatureRes);
                    return [2 /*return*/, signatureRes];
                case 2:
                    error_1 = _a.sent();
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.web3Sign = web3Sign;
function getAccountBalance(web3, account, erc20) {
    return __awaiter(this, void 0, void 0, function () {
        var trxBal, erc20Bal;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, web3.trx.getBalance(account).catch(function (error) {
                        throw "Error";
                    })];
                case 1:
                    trxBal = _a.sent();
                    erc20Bal = 0;
                    if (!erc20) return [3 /*break*/, 3];
                    return [4 /*yield*/, erc20.methods
                            .balanceOf(account)
                            .call()
                            .catch(function (error) {
                            throw "Error";
                        })];
                case 2:
                    erc20Bal = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, { ethBal: Number(trxBal), erc20Bal: Number(erc20Bal) }];
            }
        });
    });
}
exports.getAccountBalance = getAccountBalance;
function getSchemaList(networkName, schemaName) {
    // @ts-ignore
    var schemaList = index_1.schemas[networkName];
    if (!schemaList) {
        throw "Error";
    }
    if (schemaName) {
        schemaList = schemaList.filter(function (val) { return val.name === schemaName; });
    }
    if (schemaList.length === 0) {
        throw "Error";
    }
    return schemaList;
}
exports.getSchemaList = getSchemaList;
function hashOrder(web3, order) {
    return web3.utils
        .soliditySha3({ type: 'address', value: order.exchange }, { type: 'address', value: order.maker }, { type: 'address', value: order.taker }, { type: 'uint256', value: order.makerRelayerFee }, { type: 'uint256', value: order.takerRelayerFee }, { type: 'uint256', value: order.takerProtocolFee }, { type: 'uint256', value: order.takerProtocolFee }, { type: 'address', value: order.feeRecipient }, { type: 'uint8', value: order.feeMethod }, { type: 'uint8', value: order.side }, { type: 'uint8', value: order.saleKind }, { type: 'address', value: order.target }, { type: 'uint8', value: order.howToCall }, { type: 'bytes', value: order.dataToCall }, { type: 'bytes', value: order.replacementPattern }, { type: 'address', value: order.staticTarget }, { type: 'bytes', value: order.staticExtradata }, { type: 'address', value: order.paymentToken }, { type: 'uint256', value: order.basePrice }, { type: 'uint256', value: order.extra }, { type: 'uint256', value: order.listingTime }, { type: 'uint256', value: order.expirationTime }, { type: 'uint256', value: order.salt })
        .toString('hex');
}
exports.hashOrder = hashOrder;
function orderParamsEncode(order) {
    var orderParamKeys = [
        'exchange',
        'maker',
        'taker',
        'makerRelayerFee',
        'takerRelayerFee',
        'makerProtocolFee',
        'takerProtocolFee',
        'feeRecipient',
        'feeMethod',
        'side',
        'saleKind',
        'target',
        'howToCall',
        'dataToCall',
        'replacementPattern',
        'staticTarget',
        'staticExtradata',
        'paymentToken',
        'basePrice',
        'extra',
        'listingTime',
        'expirationTime',
        'salt'
    ];
    var orderParamValueArray = [];
    for (var _i = 0, orderParamKeys_1 = orderParamKeys; _i < orderParamKeys_1.length; _i++) {
        var key = orderParamKeys_1[_i];
        // @ts-ignore
        var val = order[key];
        if (val === undefined) {
            console.log('orderParamsEncode key undefined', key);
            continue;
        }
        if (constants_1.BigNumber.isBigNumber(val)) {
            val = val.toString();
        }
        orderParamValueArray.push(val);
    }
    return orderParamValueArray;
}
exports.orderParamsEncode = orderParamsEncode;
function orderSigEncode(order) {
    var orderSigKeys = ['v', 'r', 's'];
    var orderSigValueArray = [];
    for (var _i = 0, orderSigKeys_1 = orderSigKeys; _i < orderSigKeys_1.length; _i++) {
        var key = orderSigKeys_1[_i];
        // @ts-ignore
        if (order[key] === undefined) {
            console.log('orderSigEncode key undefined', key);
            continue;
        }
        // @ts-ignore
        orderSigValueArray.push(order[key]);
    }
    return orderSigValueArray;
}
exports.orderSigEncode = orderSigEncode;
function getTokenList(networkName, _a) {
    var symbol = _a.symbol, address = _a.address;
    // @ts-ignore
    var payTokens = tokens_1.tokens[networkName];
    if (symbol) {
        return __spreadArray([], payTokens.otherTokens, true).filter(function (x) { return x.symbol === symbol; });
    }
    if (address) {
        return __spreadArray([], payTokens.otherTokens, true).filter(function (x) { return x.address === address; });
    }
    return __spreadArray([], payTokens.otherTokens, true);
}
exports.getTokenList = getTokenList;
var checkResult = function (index, web3, defer, signedTransaction) {
    if (index === void 0) { index = 0; }
    return __awaiter(void 0, void 0, void 0, function () {
        var output, contract_address, latestBlock, latestBlockNumber, txBlockNumber, confirmationNumber;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (index === 60) {
                        return [2 /*return*/, defer.reject({
                                error: 'Cannot find result in solidity node',
                                transaction: signedTransaction
                            })];
                    }
                    return [4 /*yield*/, web3.trx.getTransactionInfo(signedTransaction.txID)];
                case 1:
                    output = _a.sent();
                    if (!Object.keys(output).length) {
                        return [2 /*return*/, setTimeout(function () {
                                (0, exports.checkResult)(index + 1, web3, defer, signedTransaction);
                            }, 3000)];
                    }
                    if (output.result && output.result === 'FAILED') {
                        return [2 /*return*/, defer.reject({
                                error: web3.toUtf8(output.resMessage),
                                transaction: signedTransaction,
                                output: output
                            })];
                    }
                    if (!('contractResult' in output)) {
                        return [2 /*return*/, defer.reject({
                                error: 'Failed to execute: ' + JSON.stringify(output, null, 2),
                                transaction: signedTransaction,
                                output: output
                            })];
                    }
                    if ('contract_address' in output) {
                        contract_address = web3.address.fromHex(output['contract_address']);
                        return [2 /*return*/, defer.resolve(contract_address)];
                    }
                    defer.eventEmitter.emit('receipt', { transaction: signedTransaction, output: output });
                    return [4 /*yield*/, web3.trx.getBlock('latest')];
                case 2:
                    latestBlock = _a.sent();
                    latestBlockNumber = latestBlock.block_header.raw_data.number;
                    txBlockNumber = output.blockNumber;
                    confirmationNumber = latestBlockNumber - txBlockNumber;
                    return [2 /*return*/, defer.eventEmitter.emit('confirmation', confirmationNumber, output, signedTransaction)];
            }
        });
    });
};
exports.checkResult = checkResult;
var checkResultFast = function (index, web3, defer, signedTransaction) {
    if (index === void 0) { index = 0; }
    return __awaiter(void 0, void 0, void 0, function () {
        var output, latestBlock, latestBlockNumber, txBlockNumber, confirmationNumber;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (index === 30) {
                        return [2 /*return*/, defer.reject({
                                error: 'Cannot find result in full-node',
                                transaction: signedTransaction
                            })];
                    }
                    return [4 /*yield*/, web3.trx.getUnconfirmedTransactionInfo(signedTransaction.txID)];
                case 1:
                    output = _a.sent();
                    if (!Object.keys(output).length) {
                        return [2 /*return*/, setTimeout(function () {
                                (0, exports.checkResultFast)(index + 1, web3, defer, signedTransaction);
                            }, 2000)];
                    }
                    // TODO: the receipt may be repeated
                    if (output.receipt) {
                        defer.eventEmitter.emit('receipt', { transaction: signedTransaction, output: output });
                    }
                    if (output.result && output.result === 'FAILED') {
                        return [2 /*return*/, defer.reject({
                                error: web3.toUtf8(output.resMessage),
                                transaction: signedTransaction,
                                output: output
                            })];
                    }
                    if (output.receipt && output.receipt.result !== 'SUCCESS') {
                        return [2 /*return*/, defer.reject({
                                error: web3.toUtf8(output.resMessage),
                                transaction: signedTransaction,
                                output: output
                            })];
                    }
                    if (!('contractResult' in output)) {
                        return [2 /*return*/, defer.reject({
                                error: 'Failed to execute: ' + JSON.stringify(output, null, 2),
                                transaction: signedTransaction,
                                output: output
                            })];
                    }
                    return [4 /*yield*/, web3.trx.getBlock('latest')];
                case 2:
                    latestBlock = _a.sent();
                    latestBlockNumber = latestBlock.block_header.raw_data.number;
                    txBlockNumber = output.blockNumber;
                    confirmationNumber = latestBlockNumber - txBlockNumber;
                    if (confirmationNumber > 4) {
                        defer.eventEmitter.emit('confirmation', confirmationNumber, output, signedTransaction);
                        if ('contract_address' in output) {
                            output['contract_address'] = web3.address.fromHex(output['contract_address']);
                            return [2 /*return*/, defer.resolve(output)];
                        }
                    }
                    // If the confirmationNumber < 5, issues the confirmed block height, and continues to wait
                    defer.eventEmitter.emit('confirming', confirmationNumber, output, signedTransaction);
                    setTimeout(function () {
                        (0, exports.checkResultFast)(index + 1, web3, defer, signedTransaction);
                    }, 2000);
                    return [2 /*return*/];
            }
        });
    });
};
exports.checkResultFast = checkResultFast;
function Sleep(ms) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    setTimeout(function () {
                        resolve({ status: 'wakeUp' });
                    }, ms);
                })];
        });
    });
}
exports.Sleep = Sleep;
var orderFromJSON = function (order) {
    var createdDate = new Date();
    var orderHash = order.hash || order.orderHash;
    var fromJSON = {
        hash: orderHash,
        cancelledOrFinalized: order.cancelled || order.finalized,
        markedInvalid: order.marked_invalid,
        metadata: order.metadata,
        quantity: new constants_1.BigNumber(order.quantity || 1),
        exchange: order.exchange,
        makerAccount: order.maker,
        takerAccount: order.taker,
        maker: order.maker,
        taker: order.taker,
        makerRelayerFee: new constants_1.BigNumber(order.makerRelayerFee),
        takerRelayerFee: new constants_1.BigNumber(order.takerRelayerFee),
        makerProtocolFee: new constants_1.BigNumber(order.makerProtocolFee),
        takerProtocolFee: new constants_1.BigNumber(order.takerProtocolFee),
        makerReferrerFee: new constants_1.BigNumber(order.makerReferrerFee || 0),
        waitingForBestCounterOrder: order.feeRecipient == constants_1.NULL_ADDRESS,
        feeMethod: order.feeMethod,
        feeRecipientAccount: order.feeRecipient,
        feeRecipient: order.feeRecipient,
        side: order.side,
        saleKind: order.saleKind,
        target: order.target,
        howToCall: order.howToCall,
        dataToCall: order.dataToCall,
        replacementPattern: order.replacementPattern,
        staticTarget: order.staticTarget,
        staticExtradata: order.staticExtradata,
        paymentToken: order.paymentToken,
        basePrice: new constants_1.BigNumber(order.basePrice),
        extra: new constants_1.BigNumber(order.extra),
        currentBounty: new constants_1.BigNumber(order.currentBounty || 0),
        currentPrice: new constants_1.BigNumber(order.currentPrice || 0),
        createdTime: new constants_1.BigNumber(Math.round(createdDate.getTime() / 1000)),
        listingTime: new constants_1.BigNumber(order.listingTime),
        expirationTime: new constants_1.BigNumber(order.expirationTime),
        salt: new constants_1.BigNumber(order.salt),
        v: Number.parseInt(order.v),
        r: order.r,
        s: order.s,
        paymentTokenContract: order.paymentToken || undefined,
        asset: order.asset || undefined,
        assetBundle: order.assetBundle || undefined
    };
    return fromJSON;
};
exports.orderFromJSON = orderFromJSON;
